import { render } from "./LabInfo.vue?vue&type=template&id=5959d242"
import script from "./LabInfo.vue?vue&type=script&lang=js"
export * from "./LabInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/labs/LabInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5959d242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5959d242', __exports__)) {
    console.log('reload')
    api.reload('5959d242', __exports__)
  }
  
  module.hot.accept("./LabInfo.vue?vue&type=template&id=5959d242", () => {
    console.log('re-render')
    api.rerender('5959d242', render)
  })

}


export default __exports__